__turbopack_context__.v({
  "desktopLinks": "Footer-module__JGhRua__desktopLinks",
  "desktopLinksColumn": "Footer-module__JGhRua__desktopLinksColumn",
  "expandIcon": "Footer-module__JGhRua__expandIcon",
  "footer": "Footer-module__JGhRua__footer",
  "link": "Footer-module__JGhRua__link",
  "mobileLinks": "Footer-module__JGhRua__mobileLinks",
  "phone": "Footer-module__JGhRua__phone",
  "phoneNumber": "Footer-module__JGhRua__phoneNumber",
});
